export default "__VITE_ASSET__52e5b249__"